<div class="row">
  <div class="col-12">
    <dynamic-form *ngIf="formFiltro" [fields]="formFiltro" header="<b>Administrador de Notificaciones </b>"
      (submit)="buscar($event)">
    </dynamic-form>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div>
      <app-table [botonesCustom]="botonesCustom" [buttonsRowConfig]="buttonsRowConfig" [headerConfig]="headerConfig"
        [pageEvent]="paginadoEvent" (changePage)="onChangePage($event)" (changeSize)="onChangeSize($event)"
        [size]="size"></app-table>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 text-right p-4">
    <button type="button" class="btn btn-secondary" (click)="cerrar()">Cerrar</button>
  </div>
</div>